
$(document).ready(function() {

    $('.products-list, #shopify-section-product-recommendations').on('click', '.swatches_list .swatch_color', function() {

        var scrImage = $(this).attr('data-thumb');
        var href = $(this).attr('data-href');

        var product = $(this).parents('.product__wrapper');
        var productImage = product.find('.product-image');
        var productHref = product.find('a');
        productImage.attr('src', scrImage);
        productImage.attr('srcset', scrImage);
        productHref.attr('href', href);
    });
    $('.product-tile__variant').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = $(this).attr('data-link-proxy');
    });
});
